import React from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useForm } from 'react-hook-form'
import { Col, Form } from 'react-bootstrap'
import { setParticipantViaCode } from '../../store/participant/participant'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../store'

export type ParticipantCodeFormType = {
  code: string
  birthday: string
  email: string
}

export const ParticipantCodeForm = (props: {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const dispatch = useAppDispatch()
  const { setShow } = props
  const { register, handleSubmit } = useForm<ParticipantCodeFormType>()
  const { data: program } = useAppSelector((state: RootState) => state.program)
  const navigate = useNavigate()
  const onSubmit = handleSubmit(async (data: ParticipantCodeFormType) => {
    // Trim whitespace from code
    const trimmedData = {
      ...data,
      code: data.code.trim()
    }
    dispatch(setParticipantViaCode(trimmedData, program, setShow, navigate))
  })

  return (
    <Form onSubmit={onSubmit} id='codeForm'>
      <Form.Row>
        <Col>
          <Form.Group controlId='codeForm-code'>
            <Form.Label>Zugangscode:</Form.Label>
            <Form.Control
              type='text'
              defaultValue=''
              {...register('code')}
            />
          </Form.Group>
        </Col>
      </Form.Row>
      <Form.Row>
        <Col>
          <Form.Group controlId='codeForm-birthday'>
            <Form.Label>Geburtsdatum:</Form.Label>
            <Form.Control defaultValue='' {...register('birthday')} />
          </Form.Group>
        </Col>
      </Form.Row>
      <Form.Row>
        <Col>
          <Form.Group controlId='codeForm-email'>
            <Form.Label>E-Mail-Adresse:</Form.Label>
            <Form.Control
              type='text'
              defaultValue=''
              {...register('email')}
            />
          </Form.Group>
        </Col>
      </Form.Row>
    </Form>
  )
}
